import React, { useEffect, useRef, useState } from 'react';
import './SnakeGame.css';

const SnakeGame = () => {
  const canvasRef = useRef(null);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const gameStateRef = useRef({
    snake: [{ x: 10, y: 10 }],
    food: { x: 15, y: 15 },
    direction: { x: 1, y: 0 },
    nextDirection: { x: 1, y: 0 },
    score: 0,
    gridSize: 20,
    tileCount: 30,
  });

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const game = gameStateRef.current;
    let gameInterval;

    const handleKeyPress = (e) => {
      const { direction, nextDirection } = game;
      
      if (e.code === 'ArrowUp' && direction.y === 0) {
        game.nextDirection = { x: 0, y: -1 };
      } else if (e.code === 'ArrowDown' && direction.y === 0) {
        game.nextDirection = { x: 0, y: 1 };
      } else if (e.code === 'ArrowLeft' && direction.x === 0) {
        game.nextDirection = { x: -1, y: 0 };
      } else if (e.code === 'ArrowRight' && direction.x === 0) {
        game.nextDirection = { x: 1, y: 0 };
      } else if (e.code === 'Space' && gameOver) {
        e.preventDefault();
        resetGame();
      }
    };

    const resetGame = () => {
      game.snake = [{ x: 10, y: 10 }];
      game.food = { x: 15, y: 15 };
      game.direction = { x: 1, y: 0 };
      game.nextDirection = { x: 1, y: 0 };
      game.score = 0;
      setScore(0);
      setGameOver(false);
    };

    const generateFood = () => {
      let newFood;
      do {
        newFood = {
          x: Math.floor(Math.random() * game.tileCount),
          y: Math.floor(Math.random() * game.tileCount),
        };
      } while (game.snake.some(segment => segment.x === newFood.x && segment.y === newFood.y));
      game.food = newFood;
    };

    const gameLoop = () => {
      game.direction = game.nextDirection;

      // Nouvelle position de la tête
      const head = {
        x: game.snake[0].x + game.direction.x,
        y: game.snake[0].y + game.direction.y,
      };

      // Vérifier collision avec les murs
      if (head.x < 0 || head.x >= game.tileCount || head.y < 0 || head.y >= game.tileCount) {
        setGameOver(true);
        return;
      }

      // Vérifier collision avec soi-même
      if (game.snake.some(segment => segment.x === head.x && segment.y === head.y)) {
        setGameOver(true);
        return;
      }

      game.snake.unshift(head);

      // Vérifier si le serpent mange la nourriture
      if (head.x === game.food.x && head.y === game.food.y) {
        game.score += 10;
        setScore(game.score);
        generateFood();
      } else {
        game.snake.pop();
      }

      // Dessiner
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Grille
      ctx.strokeStyle = '#ddd';
      for (let i = 0; i <= game.tileCount; i++) {
        ctx.beginPath();
        ctx.moveTo(i * game.gridSize, 0);
        ctx.lineTo(i * game.gridSize, canvas.height);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, i * game.gridSize);
        ctx.lineTo(canvas.width, i * game.gridSize);
        ctx.stroke();
      }

      // Serpent
      game.snake.forEach((segment, index) => {
        ctx.fillStyle = index === 0 ? '#667eea' : '#764ba2';
        ctx.fillRect(
          segment.x * game.gridSize + 1,
          segment.y * game.gridSize + 1,
          game.gridSize - 2,
          game.gridSize - 2
        );
      });

      // Nourriture (livre)
      ctx.fillStyle = '#e74c3c';
      ctx.fillRect(
        game.food.x * game.gridSize + 1,
        game.food.y * game.gridSize + 1,
        game.gridSize - 2,
        game.gridSize - 2
      );
      ctx.fillStyle = 'white';
      ctx.font = '12px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('📚', game.food.x * game.gridSize + game.gridSize / 2, game.food.y * game.gridSize + game.gridSize / 2 + 4);
    };

    window.addEventListener('keydown', handleKeyPress);
    
    if (!gameOver) {
      gameInterval = setInterval(gameLoop, 150);
    } else {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'white';
      ctx.font = 'bold 30px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('GAME OVER', canvas.width / 2, canvas.height / 2 - 20);
      ctx.font = '20px Arial';
      ctx.fillText(`Score: ${game.score}`, canvas.width / 2, canvas.height / 2 + 20);
      ctx.font = '16px Arial';
      ctx.fillText('Appuyez sur ESPACE pour rejouer', canvas.width / 2, canvas.height / 2 + 60);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      clearInterval(gameInterval);
    };
  }, [gameOver]);

  return (
    <div className="game-container">
      <h3>🐍 Snake Academy</h3>
      <p className="game-instructions">Utilisez les FLÈCHES pour diriger le serpent et collecter des livres 📚</p>
      <canvas ref={canvasRef} width={600} height={600} className="game-canvas" />
      <div className="game-score">Livres collectés: {Math.floor(score / 10)}</div>
    </div>
  );
};

export default SnakeGame;















